import {
  getStorage,
  readStorageJSON,
  removeStorageItem,
  writeStorageJSON,
  writeStorageItem
} from '@/utils/secure-storage';

export const PROFILE_STORAGE_KEY = 'h5:profile';
const PROFILE_EXPIRE_AT_KEY = 'h5:profile-expire-at';
const PROFILE_EXPIRE_MS = 7 * 24 * 60 * 60 * 1000;
const USER_STORAGE_KEYS = [
  PROFILE_STORAGE_KEY,
  PROFILE_EXPIRE_AT_KEY,
  'h5:card-order',
  'wallet-mnemonic',
  'wallet-password',
  'wallet-signer-secret',
  'wallet-import-secret',
  'wallet-sensitive-export',
  'card-info-access'
];

function hasProfileAuth(profile) {
  if (!profile || typeof profile !== 'object') {
    return false;
  }

  const currentAccount = profile.currentAccount || {};
  const address = String(
    currentAccount.address
      || currentAccount.ethAddress
      || currentAccount.tronAddress
      || currentAccount.addressTron
      || currentAccount.trxAddress
      || currentAccount.bitcoinAddress
      || currentAccount.btcAddress
      || currentAccount.addressBtc
      || ''
  ).trim();

  return Boolean(address || profile.token);
}

export function clearPersistedUserData() {
  const storage = getStorage('local');
  const sessionStorage = getStorage('session');
  USER_STORAGE_KEYS.forEach((key) => {
    removeStorageItem(key, { storage });
    removeStorageItem(key, { storage: sessionStorage });
  });
}

export function loadProfile() {
  const storage = getStorage('local');
  const sessionStorage = getStorage('session');
  let profile = readStorageJSON(PROFILE_STORAGE_KEY, null, {
    storage
  });

  if (!profile) {
    profile = readStorageJSON(PROFILE_STORAGE_KEY, null, {
      storage: sessionStorage
    });
    if (profile) {
      writeStorageJSON(PROFILE_STORAGE_KEY, profile, { storage });
    }
  }

  const sessionExpireAt = readStorageJSON(PROFILE_EXPIRE_AT_KEY, 0, {
    storage: sessionStorage
  });
  const localExpireAt = readStorageJSON(PROFILE_EXPIRE_AT_KEY, 0, {
    storage
  });

  if (!localExpireAt && sessionExpireAt) {
    writeStorageItem(PROFILE_EXPIRE_AT_KEY, String(sessionExpireAt), { storage });
  }

  removeStorageItem(PROFILE_STORAGE_KEY, { storage: sessionStorage });
  removeStorageItem(PROFILE_EXPIRE_AT_KEY, { storage: sessionStorage });

  if (!profile) {
    return null;
  }

  if (!hasProfileAuth(profile)) {
    removeStorageItem(PROFILE_EXPIRE_AT_KEY, { storage });
    return profile;
  }

  const expireAt = Number(readStorageJSON(PROFILE_EXPIRE_AT_KEY, 0, {
    storage
  }) || 0);

  if (expireAt && Date.now() > expireAt) {
    clearPersistedUserData();
    return null;
  }

  if (!expireAt) {
    writeStorageItem(PROFILE_EXPIRE_AT_KEY, String(Date.now() + PROFILE_EXPIRE_MS), {
      storage
    });
  }

  return profile;
}

export function saveProfile(profile) {
  const storage = getStorage('local');
  const sessionStorage = getStorage('session');
  writeStorageJSON(PROFILE_STORAGE_KEY, profile || {}, {
    storage
  });
  removeStorageItem(PROFILE_STORAGE_KEY, { storage: sessionStorage });

  if (hasProfileAuth(profile)) {
    const currentExpireAt = Number(readStorageJSON(PROFILE_EXPIRE_AT_KEY, 0, {
      storage
    }) || 0);
    if (!currentExpireAt) {
      writeStorageItem(PROFILE_EXPIRE_AT_KEY, String(Date.now() + PROFILE_EXPIRE_MS), {
        storage
      });
    }
    removeStorageItem(PROFILE_EXPIRE_AT_KEY, { storage: sessionStorage });
    return;
  }

  removeStorageItem(PROFILE_EXPIRE_AT_KEY, { storage });
  removeStorageItem(PROFILE_EXPIRE_AT_KEY, { storage: sessionStorage });
}
